/**
 * axios实例化，
 * 两种使用方式：
 * 1.可以单独作为网络请求库使用
 * 2.也可以通过api.js封装后在使用
 *
 * axios官方地址：https://github.com/axios/axios
 */
import axios from 'axios';
import { AXIOS_DEFAULT_CONFIG } from '@/config/index';
import {
	requestSuccessFunc,
	requestFailFunc,
	responseSuccessFunc,
	responseFailFunc
} from '@/config/interceptors/axios';

let axiosInstance = {};

axiosInstance = axios.create(AXIOS_DEFAULT_CONFIG);

// 注入请求拦截
axiosInstance.interceptors.request.use(requestSuccessFunc, requestFailFunc);
// 注入失败拦截
axiosInstance.interceptors.response.use(responseSuccessFunc, responseFailFunc);

export default axiosInstance;
